import { parseCookies } from '@cian/utils';

import { SESSION_CIAN_APP_TOOLTIP_KEY } from './constants';

export const getTooltipCloseFromCookie = () => {
  return parseInt(parseCookies(document.cookie)[SESSION_CIAN_APP_TOOLTIP_KEY], 10);
};
